import { makeStyles } from '@material-ui/core';
import { COLORS } from '../../../../constants';

const style = {
  heading: {
    textAlign: 'center',
    fontSize: '2rem',
    paddingTop: '2rem',
  },
  searchBox: {
    marginBottom: '2rem',
  },
  tableContainer: {
    backgroundColor: COLORS.WHITE,
    margin: '2rem',
    padding: '1rem',
  },
  inputDiv: {
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: '20px',
    paddingBottom: '20px',
    borderRadius: '5px',
  },
  inputForm: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: '1rem',
    paddingBottom: '1rem',
  },
  button: {
    fontSize: '1.1rem',
    color: COLORS.WHITE,
    backgroundColor: COLORS.GREEN,
  },
  buttonRej: {
    width: '100%',
    fontSize: '0.9rem',
    color: COLORS.WHITE,
    backgroundColor: COLORS.GREY_DARKER,
  },
  buttonApprove: {
    width: '100%',
    fontSize: '0.9rem',
    color: COLORS.WHITE,
    backgroundColor: COLORS.GREEN,
  },
  buttonInv: {
    fontSize: '1.1rem',
    marginTop: '1rem',
    color: COLORS.GREEN,
    backgroundColor: COLORS.WHITE,
  },
  loading: {
    textAlign: 'center',
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  BuilderResults: {
    width: '60%',
    margin: '2rem auto',
  },
  loadingWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 200,
  },
};
const useStyles = makeStyles(theme => ({
  root: {
    border: 0,
    color:
      theme.palette.type === 'light'
        ? 'rgba(0,0,0,.85)'
        : 'rgba(255,255,255,0.85)',
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    WebkitFontSmoothing: 'auto',
    letterSpacing: 'normal',
    '& .MuiDataGrid-columnsContainer': {
      backgroundColor: COLORS.GREY,
    },
    '& .MuiDataGrid-iconSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-colCell, .MuiDataGrid-cell': {
      borderRight: `0px'
      }`,
    },
    '& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell': {
      borderBottom: `2px solid ${
        theme.palette.type === 'light' ? '#f0f0f0' : '#303030'
      }`,
    },
    '& .MuiDataGrid-cell': {
      color:
        theme.palette.type === 'light'
          ? 'rgba(0,0,0,.85)'
          : 'rgba(255,255,255,0.65)',
    },
    '& .MuiPaginationItem-root': {
      borderRadius: 0,
    },
  },
}));
export default { style, useStyles };
